// components/home.jsx
import React, { useState } from "react";
import Hero from "./Hero";
import Features from "./Features";
import OutletTypes from "./OutletTypes";
import HowItWorks from "./HowItWorks";
import Pricing from "./Pricing";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import DemoForm from "./DemoForm";

const Home = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleAddToCart = (plan) => {
    setSelectedPlan(plan);

    // Scroll to the form section
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Hero />
      <Features />
      <OutletTypes />
      <HowItWorks />
      <Pricing addToCart={handleAddToCart} />
      <Testimonials />
      <FAQ />
      <DemoForm selectedPlan={selectedPlan} />
    </>
  );
};

export default Home;